import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#layout" }),
    /*#__PURE__*/_createTextVNode(" Layout ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Quickly and easily create layouts with the basic 24-column. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUILayoutBasic = _resolveComponent("EUILayoutBasic")
  const _component_EUIColumnSpacing = _resolveComponent("EUIColumnSpacing")
  const _component_EUIHybridLayout = _resolveComponent("EUIHybridLayout")
  const _component_EUIColumnOffset = _resolveComponent("EUIColumnOffset")
  const _component_EUIAlignment = _resolveComponent("EUIAlignment")
  const _component_EUIResponsiveLayout = _resolveComponent("EUIResponsiveLayout")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUILayoutBasic),
    _createVNode(_component_EUIColumnSpacing),
    _createVNode(_component_EUIHybridLayout),
    _createVNode(_component_EUIColumnOffset),
    _createVNode(_component_EUIAlignment),
    _createVNode(_component_EUIResponsiveLayout)
  ], 64))
}